/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { getFileUrl } from "@/lib/get-file-url";
import { useEffect, useState } from "react";

export const useImageDocDisplay = (file: string) => {
  const [genericState, setGenericState] = useState<any>({
    loading: true,
    url: undefined,
    error: undefined,
  });
  useEffect(() => {
    (async () => {
      try {
        if (file) {
          // const BASE_URL = import.meta.env.VITE_S3_PROXY_TARGET;

          const url_0 = await getFileUrl(file);
          // const url_1 = "/s3-proxy" + url_0.replace(BASE_URL, "");

          const url = await convertTextToPng(url_0);
          setGenericState((prev: any) => ({
            ...prev,
            loading: false,
            url: url,
          }));
        }
      } catch (error) {
        setGenericState((prev: any) => ({
          ...prev,
          error: true,
        }));
        console.log({ error });
      }
    })();
  }, [file]);

  async function convertTextToPng(url_1: string) {
    const url = url_1;

    try {
      // Fetch the text file
      const response = await fetch(url);
      const text = await response.text();

      // Create a temporary canvas to measure text width
      const tempCanvas = document.createElement("canvas");
      const tempCtx: any = tempCanvas.getContext("2d");
      tempCtx.font = "16px Arial";

      // Define max width and dynamically calculate height
      const maxWidth = 800; // Fixed width
      const lineHeight = 24; // Line spacing
      const words = text.split("\n");

      const lines: any = [];
      words.forEach((line) => {
        const wordsInLine = line.split(" ");
        let currentLine = "";
        wordsInLine.forEach((word) => {
          const testLine = currentLine + word + " ";
          const testWidth = tempCtx.measureText(testLine).width;
          if (testWidth > maxWidth) {
            lines.push(currentLine);
            currentLine = word + " ";
          } else {
            currentLine = testLine;
          }
        });
        lines.push(currentLine);
      });

      const totalHeight = lines.length * lineHeight + 40; // Extra padding

      // Create actual canvas
      const canvas = document.createElement("canvas");
      canvas.width = maxWidth;
      canvas.height = totalHeight;
      const ctx: any = canvas.getContext("2d");

      // Set background color
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Set text style
      ctx.fillStyle = "#000000";
      ctx.font = "16px Arial";

      // Draw text line by line
      let y = 30;
      lines.forEach((line: any) => {
        ctx.fillText(line, 20, y);
        y += lineHeight;
      });

      // Convert canvas to PNG and return URL
      return canvas.toDataURL("image/png");
    } catch (error) {
      console.error("Error fetching or converting text:", error);
      setGenericState((prev: any) => ({
        ...prev,
        error: true,
      }));

      return null;
    }
  }
  return { genericState };
};
